import styled from 'styled-components';

// Libs
import {lib} from '@drivesally/sally-ui';

// Colors
const {
  colors: {red},
} = lib;

const Container = styled.div`
  width: 100%;
  height: 300px;
  font-size: 50px;
  color: ${red};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Container;
